import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative py-5 px-[18px] rounded-[15px] flex items-center space-x-5 bg-gray-30" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/coming-soon.png",
  alt: "image",
  class: "w-[110px] h-[110px] object-cover rounded-[5px] flex-shrink-0"
}, null, -1)
const _hoisted_3 = { class: "space-y-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-darkgray-400" }, "Coming Soon", -1)
const _hoisted_5 = { class: "flex space-x-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, " -- ", -1)
const _hoisted_7 = { class: "flex space-x-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, " -- ", -1)

import { MapPinIcon, PhoneIcon } from "@heroicons/vue/24/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'ComingSoonBranchCard',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("a", _hoisted_5, [
        _createVNode(_unref(MapPinIcon), { class: "w-[18px] h-[18px] flex-shrink-0 text-darkgray-400 mt-0.5" }),
        _hoisted_6
      ]),
      _createElementVNode("a", _hoisted_7, [
        _createVNode(_unref(PhoneIcon), { class: "w-[18px] h-[18px] flex-shrink-0 text-darkgray-400 mt-0.5" }),
        _hoisted_8
      ])
    ])
  ]))
}
}

})